/**
 * What the web build shows. Get the iOS app was hidden until there was something to get (Daniel,
 * 2026-10-17); since 2026-10-23 it leads to the public beta on TestFlight: its menu row and page,
 * the link on the start sheet, the button in the desktop top bar and the promotion in settings
 * all follow this.
 */
export const SHOW_GET_APP = true;

/**
 * The yellow beta band on the start sheet and the menu, with its page (decision 0044). Off at the
 * launch; /beta itself stays until it is taken out with the band.
 */
export const SHOW_BETA = true;

/** The iOS app's public beta (docs/release.md, External testing), until the App Store has it. */
export const TESTFLIGHT_URL = "https://testflight.apple.com/join/XHEKyPtP";

/** Where feedback and questions about privacy go (Daniel, 2026-10-17). */
export const CONTACT_EMAIL = "hi@greatscott.se";
